export default __webpack_public_path__ + "static/media/icon3.3b89815e.jpg";